module.exports = __webpack_public_path__ + "img/m_icon2.c924ab51.png";